import { SessionBySmsResponse, CustomerDataResponse } from "../types/ClaroMultiBff";

export const mockedSmsResponseData: Record<string, SessionBySmsResponse> = {
  '94278965079': {
    sessionId: '6f8d7c7d-7e4d-4dc4-9f98-1a9dc5d10b01-94278965079',
  },
  '71724684060': {
    sessionId: '0f23d9b8-0db8-4e1e-88e6-a7f5701f8c02-71724684060',
  },
  '71870208056': {
    sessionId: '2c6a95e2-3b71-46d3-96c2-1a3984e2ab03-71870208056',
  },
  '51944045066': {
    sessionId: 'b38af8ad-aef3-4378-9afd-c6c2d0415d04-51944045066',
  },
  '78701196014': {
    sessionId: '95730209-8d6f-4e8e-ad8c-7cfd2b9f2f05-78701196014',
  },
  '30389125067': {
    sessionId: 'e4bf8795-d4f7-4d88-a8b0-27ea9f5ab406-30389125067',
  },
  '87448761064': {
    sessionId: '7a43f1e4-b6a8-4f8d-bb7f-2a7b2ed17d07-87448761064',
  },
  '45510237015': {
    sessionId: '4c501868-2b8d-48cf-8dfb-8f087c4f4d08-45510237015',
  },
  '72795594099': {
    sessionId: 'd2a73ad2-0eaf-4ed8-a98e-b6f2d7e7d309-72795594099',
  },
  '60135869005': {
    sessionId: '1f88db01-6f55-4f2e-b19a-3b7f94f0de10-60135869005',
  },
  '32477771051': {
    sessionId: 'a95da94f-89f5-4532-969e-a9be5b4e9411-32477771051',
  },
  '73292476003': {
    sessionId: 'c65de802-2f48-4ae4-9237-fd8aa9df2312-73292476003',
  },
}

export const mockedTokenAAResponseData: Record<string, CustomerDataResponse> = {
  '6f8d7c7d-7e4d-4dc4-9f98-1a9dc5d10b01-94278965079': {
    planName: 'Claro Controle 20GB',
    planValue: 69.9,
    planType: 'CONTROLE',
    addresses: [
      {
        zipcode: '01310930',
        number: '100',
        city: 'São Paulo',
        state: 'SP',
        country: 'Brasil',
      },
    ],
    dependents: [
      {
        msisdn: '11988887777',
        planType: 'DEPENDENTE_CONTROLE',
        planValue: 29.9,
      },
    ],
    dependentInfoNote: 'Dependente ativo no ciclo atual.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'João da Silva',
    cpf: '94278965079',
    rg: '345678901',
    birthDate: '1989-04-15',
    motherName: 'Maria da Silva',
    contactEmail: 'joao.silva@email.com',
    paymentType: 'CARTAO_CREDITO',
    invoiceAddress: {
      postalCode: '01310930',
      streetNumber: '100',
    },
    paymentDay: '10',
  },
  '0f23d9b8-0db8-4e1e-88e6-a7f5701f8c02-71724684060': {
    planName: 'Claro Pós 50GB',
    planValue: 119.9,
    planType: 'POS',
    addresses: [
      {
        zipcode: '20040002',
        number: '250',
        city: 'Rio de Janeiro',
        state: 'RJ',
        country: 'Brasil',
      },
    ],
    dependents: [
      {
        msisdn: '21997776666',
        planType: 'DEPENDENTE_POS',
        planValue: 39.9,
      },
      {
        msisdn: '21996665555',
        planType: 'DEPENDENTE_POS',
        planValue: 39.9,
      },
    ],
    dependentInfoNote: '2 dependentes vinculados.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Ana Pereira',
    cpf: '71724684060',
    rg: '234567890',
    birthDate: '1992-09-21',
    motherName: 'Claudia Pereira',
    contactEmail: 'ana.pereira@email.com',
    paymentType: 'DEBITO_AUTOMATICO',
    invoiceAddress: {
      postalCode: '20040002',
      streetNumber: '250',
    },
    paymentDay: '05',
  },
  '2c6a95e2-3b71-46d3-96c2-1a3984e2ab03-71870208056': {
    planName: 'Claro Flex 15GB',
    planValue: 49.9,
    planType: 'FLEX',
    addresses: [
      {
        zipcode: '30140071',
        number: '45',
        city: 'Belo Horizonte',
        state: 'MG',
        country: 'Brasil',
      },
    ],
    dependents: [],
    dependentInfoNote: 'Sem dependentes cadastrados.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Carlos Mendes',
    cpf: '71870208056',
    rg: '456789012',
    birthDate: '1985-01-30',
    motherName: 'Teresa Mendes',
    contactEmail: 'carlos.mendes@email.com',
    paymentType: 'PIX',
    invoiceAddress: {
      postalCode: '30140071',
      streetNumber: '45',
    },
    paymentDay: '15',
  },
  'b38af8ad-aef3-4378-9afd-c6c2d0415d04-51944045066': {
    planName: 'Claro Controle 25GB',
    planValue: 79.9,
    planType: 'CONTROLE',
    addresses: [
      {
        zipcode: '80010000',
        number: '890',
        city: 'Curitiba',
        state: 'PR',
        country: 'Brasil',
      },
    ],
    dependents: [
      {
        msisdn: '41995554444',
        planType: 'DEPENDENTE_CONTROLE',
        planValue: 24.9,
      },
    ],
    dependentInfoNote: '1 dependente com franquia compartilhada.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Fernanda Lima',
    cpf: '51944045066',
    rg: '567890123',
    birthDate: '1990-07-11',
    motherName: 'Denise Lima',
    contactEmail: 'fernanda.lima@email.com',
    paymentType: 'BOLETO',
    invoiceAddress: {
      postalCode: '80010000',
      streetNumber: '890',
    },
    paymentDay: '20',
  },
  '95730209-8d6f-4e8e-ad8c-7cfd2b9f2f05-78701196014': {
    planName: 'Claro Pós 100GB',
    planValue: 169.9,
    planType: 'POS',
    addresses: [
      {
        zipcode: '70040900',
        number: '12',
        city: 'Brasília',
        state: 'DF',
        country: 'Brasil',
      },
    ],
    dependents: [
      {
        msisdn: '61994443333',
        planType: 'DEPENDENTE_POS',
        planValue: 49.9,
      },
    ],
    dependentInfoNote: 'Dependente com pacote internacional.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Marcos Oliveira',
    cpf: '78701196014',
    rg: '678901234',
    birthDate: '1982-12-02',
    motherName: 'Sonia Oliveira',
    contactEmail: 'marcos.oliveira@email.com',
    paymentType: 'CARTAO_CREDITO',
    invoiceAddress: {
      postalCode: '70040900',
      streetNumber: '12',
    },
    paymentDay: '08',
  },
  'e4bf8795-d4f7-4d88-a8b0-27ea9f5ab406-30389125067': {
    planName: 'Claro Controle 10GB',
    planValue: 59.9,
    planType: 'CONTROLE',
    addresses: [
      {
        zipcode: '50030010',
        number: '321',
        city: 'Recife',
        state: 'PE',
        country: 'Brasil',
      },
    ],
    dependents: [],
    dependentInfoNote: 'Cliente sem dependentes no momento.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Beatriz Souza',
    cpf: '30389125067',
    rg: '789012345',
    birthDate: '1995-03-09',
    motherName: 'Helena Souza',
    contactEmail: 'beatriz.souza@email.com',
    paymentType: 'BOLETO',
    invoiceAddress: {
      postalCode: '50030010',
      streetNumber: '321',
    },
    paymentDay: '12',
  },
  '7a43f1e4-b6a8-4f8d-bb7f-2a7b2ed17d07-87448761064': {
    planName: 'Claro Pós 75GB',
    planValue: 139.9,
    planType: 'POS',
    addresses: [
      {
        zipcode: '69005010',
        number: '77',
        city: 'Manaus',
        state: 'AM',
        country: 'Brasil',
      },
    ],
    dependents: [
      {
        msisdn: '92993332222',
        planType: 'DEPENDENTE_POS',
        planValue: 34.9,
      },
    ],
    dependentInfoNote: 'Dependente principal confirmado.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Ricardo Nunes',
    cpf: '87448761064',
    rg: '890123456',
    birthDate: '1987-06-18',
    motherName: 'Lucia Nunes',
    contactEmail: 'ricardo.nunes@email.com',
    paymentType: 'DEBITO_AUTOMATICO',
    invoiceAddress: {
      postalCode: '69005010',
      streetNumber: '77',
    },
    paymentDay: '03',
  },
  '4c501868-2b8d-48cf-8dfb-8f087c4f4d08-45510237015': {
    planName: 'Claro Flex 20GB',
    planValue: 59.9,
    planType: 'FLEX',
    addresses: [
      {
        zipcode: '40020000',
        number: '500',
        city: 'Salvador',
        state: 'BA',
        country: 'Brasil',
      },
    ],
    dependents: [],
    dependentInfoNote: 'Plano individual, sem dependentes.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Patrícia Rocha',
    cpf: '45510237015',
    rg: '901234567',
    birthDate: '1993-11-24',
    motherName: 'Neide Rocha',
    contactEmail: 'patricia.rocha@email.com',
    paymentType: 'PIX',
    invoiceAddress: {
      postalCode: '40020000',
      streetNumber: '500',
    },
    paymentDay: '25',
  },
  'd2a73ad2-0eaf-4ed8-a98e-b6f2d7e7d309-72795594099': {
    planName: 'Claro Controle 30GB',
    planValue: 89.9,
    planType: 'CONTROLE',
    addresses: [
      {
        zipcode: '66010000',
        number: '143',
        city: 'Belém',
        state: 'PA',
        country: 'Brasil',
      },
    ],
    dependents: [
      {
        msisdn: '91992221111',
        planType: 'DEPENDENTE_CONTROLE',
        planValue: 19.9,
      },
    ],
    dependentInfoNote: 'Dependente elegível para upgrade.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Lucas Almeida',
    cpf: '72795594099',
    rg: '012345678',
    birthDate: '1991-05-05',
    motherName: 'Marta Almeida',
    contactEmail: 'lucas.almeida@email.com',
    paymentType: 'CARTAO_CREDITO',
    invoiceAddress: {
      postalCode: '66010000',
      streetNumber: '143',
    },
    paymentDay: '07',
  },
  '1f88db01-6f55-4f2e-b19a-3b7f94f0de10-60135869005': {
    planName: 'Claro Pós 60GB',
    planValue: 129.9,
    planType: 'POS',
    addresses: [
      {
        zipcode: '64000000',
        number: '2100',
        city: 'Teresina',
        state: 'PI',
        country: 'Brasil',
      },
    ],
    dependents: [],
    dependentInfoNote: 'Cliente sem linhas adicionais.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Gabriel Costa',
    cpf: '60135869005',
    rg: '123450987',
    birthDate: '1988-08-28',
    motherName: 'Rosana Costa',
    contactEmail: 'gabriel.costa@email.com',
    paymentType: 'DEBITO_AUTOMATICO',
    invoiceAddress: {
      postalCode: '64000000',
      streetNumber: '2100',
    },
    paymentDay: '18',
  },
  'a95da94f-89f5-4532-969e-a9be5b4e9411-32477771051': {
    planName: 'Claro Flex 25GB',
    planValue: 69.9,
    planType: 'FLEX',
    addresses: [
      {
        zipcode: '59020000',
        number: '640',
        city: 'Natal',
        state: 'RN',
        country: 'Brasil',
      },
    ],
    dependents: [
      {
        msisdn: '84991110000',
        planType: 'DEPENDENTE_FLEX',
        planValue: 15.9,
      },
    ],
    dependentInfoNote: 'Dependente adicionado no último ciclo.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Juliana Martins',
    cpf: '32477771051',
    rg: '234560987',
    birthDate: '1994-02-14',
    motherName: 'Elaine Martins',
    contactEmail: 'juliana.martins@email.com',
    paymentType: 'PIX',
    invoiceAddress: {
      postalCode: '59020000',
      streetNumber: '640',
    },
    paymentDay: '22',
  },
  'c65de802-2f48-4ae4-9237-fd8aa9df2312-73292476003': {
    planName: 'Claro Controle 15GB',
    planValue: 64.9,
    planType: 'CONTROLE',
    addresses: [
      {
        zipcode: '88010000',
        number: '980',
        city: 'Florianópolis',
        state: 'SC',
        country: 'Brasil',
      },
    ],
    dependents: [],
    dependentInfoNote: 'Sem pendências e sem dependentes.',
    customerType: 'PF',
    situation: 'ATIVO',
    name: 'Thiago Fernandes',
    cpf: '73292476003',
    rg: '345670987',
    birthDate: '1986-10-10',
    motherName: 'Carla Fernandes',
    contactEmail: 'thiago.fernandes@email.com',
    paymentType: 'BOLETO',
    invoiceAddress: {
      postalCode: '88010000',
      streetNumber: '980',
    },
    paymentDay: '30',
  },
}